import UtilitiesController from './utilities-controller'
import { includes, filter } from 'lodash'

export default class extends UtilitiesController {
  static targets = ['content', 'indicator', 'trigger']

  onTriggerClick = event => {
    event.preventDefault();

    let index = event.target.dataset.index
    let openTables = filter(this.contentTargets, target => !includes(target.classList, 'hidden'))
    let currentTableHidden = this.contentTargets[index].classList.contains('hidden')

    if (openTables.length > 0) {
      openTables.forEach(table => this.close(table.dataset.index));
      if (!currentTableHidden) return
    }

    this.open(index)
  }
}
